import type { CoreApiClient } from "../client";
import type { HeatingNetwork, UpdateHeatingNetworkRequestBody } from "../types/heating-network.type";

export const createHeatingNetworkMutations = (api: CoreApiClient) => {
  const { request } = api;

  const update = async (heatingNetworkId: string, body: UpdateHeatingNetworkRequestBody): Promise<HeatingNetwork> => {
    const { data } = await request("patch", "/heating-networks/{heatingNetworkId}", {
      params: { path: { heatingNetworkId } },
      body,
    });
    return data;
  };

  return {
    update,
  };
};
